export default "__VITE_ASSET__Bgbj5kMj__"